<template>
  <div class="ui-block-content">
    <!-- Deactivate account  -->
    <form>

      <div class="row">
        <div class="col col-lg-12 col-md-12 col-sm-12 col-12">
          <div class="form-group label-floating">
            <h6 class="title">Deactive account</h6>
            <p>
              Are you sure you want to deactivate your account?
            </p>
            <div class="col col-lg-12 col-md-6 col-sm-12 col-12 deactivate-input">
              <SInput type="password" label="Confirm current password" :eyeToggle="true" ref="firstInput"
                name="current-password" autocomplete="current-password" data-cy="deactivateCurrentPasswordInput"
                v-model="currentPassword" />
            </div>
          </div>
          <button class="btn btn-lg deactivate-btn" @click="deactive" data-cy="deactivateAccountBtn">
            DEACTIVATE ACCOUNT
          </button>
        </div>
      </div>
    </form>
    <Modal id="modalDeactivate" title="Account deactivation" buttonName="OK" @button="closeModal" ref="modal"
      @hidden="doTheAction">
      <div data-cy="deactivationResultModal">{{  result  }}</div>
      <span v-if="result === 'Deactivation successful'">
        <br>You can reactivate your account at any time just by logging into the system again.
      </span>
    </Modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import UserHelperVue from "../../mixins/UserHelper.vue";
import SInput from "@/components/atoms/SInput.vue";
import Modal from "@/components/atoms/Modal.vue";
import Auth from "@/modules/Auth.js";

export default {
  name: "FormDeactivateAccount",
  data() {
    return {
      currentPassword: '',
      result: null,
    };
  },
  components: { SInput, Modal },
  computed: {
    ...mapGetters({
      user: "getUser",
    }),
  },
  mixins: [UserHelperVue],
  methods: {
    ...mapActions([
      "deactivation",
      "endSession",
    ]),
    closeModal() {
      this.$refs.modal.closeModal();
    },
    doTheAction() {
      if (this.result === "Deactivation successful") {
        this.logout();
      }
    },
    logout() {
      sessionStorage.clear();
      this.endSession();
      Auth.deauthenticateUser();
      localStorage.removeItem("user_id");
      console.log("passei1");
      this.$route.path !== "/" && this.$router.push("/");
      location.reload();
    },
    async deactive(e) {
      e.preventDefault();
      const update = {
        userId: this.user.id,
        userPassword: this.currentPassword
      }
      const res = await this.deactivation(update);
      if (res.result === "Deactivation successful" || res.error === "Current password is invalid") {
        this.result = res.result || res.error;
      } else this.result = "Something went wrong!";
      $("#modalDeactivate").modal("show");
    },
  },
};
</script>
<style scoped>
.deactivate-input {
  padding: 0;
}

.deactivate-btn {
  color: red;
  padding: 0;
  display: inherit;
  margin-left: auto;
  width: 175px;
}
</style>
